module.exports = __webpack_public_path__ + "img/pic_dianfanbao2.fa4a7347.png";